import { extendTheme } from '@chakra-ui/react';
import { globalStyles } from './styles';
import { breakpoints } from './foundations/breakpoints';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { linkStyles } from './components/link';
import { drawerStyles } from './components/drawer';
import { toastStyles } from './components/toast';
import { switchStyles } from './components/switch';
import { alertStyles } from './components/alert';
import { CardComponent } from './additions/card/Card';
import { CardBodyComponent } from './additions/card/CardBody';
import { CardHeaderComponent } from './additions/card/CardHeader';
import { MainPanelComponent } from './additions/layout/MainPanel';
import { PanelContentComponent } from './additions/layout/PanelContent';
import { PanelContainerComponent } from './additions/layout/PanelContainer';
// import { mode } from "@chakra-ui/theme-tools";
export default extendTheme(
	{ 
		breakpoints, // Breakpoints
		fonts: {
			body: "'Urbanist', sans-serif",
			heading: "'Urbanist', sans-serif",
			mono: "'Urbanist', sans-serif"
		},
		config: {
			// Set default toast position to top-right
			defaultOptions: {
				toast: {
					position: 'top-right',
				},
			},
			// Disable focus ring globally
			cssVarPrefix: 'chakra',
			useSystemColorMode: false,
		},
		// Override focus ring styles globally
		shadows: {
			outline: 'none',
		},
	},
	globalStyles,
	buttonStyles, // Button styles
	badgeStyles, // Badge styles
	linkStyles, // Link styles
	drawerStyles, // Sidebar variant for Chakra's drawer
	toastStyles, // Toast styles
	switchStyles, // Switch styles
	alertStyles, // Alert styles
	CardComponent, // Card component
	CardBodyComponent, // Card Body component
	CardHeaderComponent, // Card Header component
	MainPanelComponent, // Main Panel component
	PanelContentComponent, // Panel Content component
	PanelContainerComponent // Panel Container component
);

